import { LoadingDots } from './dots';
import { Spinner } from './spinner/spinner';
import { Shimmer } from '../loading/shimmer';
import { Form } from './form';
import { BootLoading } from './boot-loading';

export const Loading = {
  Spinner,
  Dots: LoadingDots,
  Shimmer,
  Form,
  Boot: BootLoading,
};
